import { Injectable, isDevMode } from '@angular/core';
import { AuthModel } from "../models";

@Injectable()
export class DataService {
    serviceData: any;

    authModel: AuthModel;

    paymentResponse: any;
    paymentRequest: any;

    practiceId: any;
    companyName: any;
    billingPhone: any;
    maxFailedCount: any;
    failedMinutes: any;

    public getLogoUrl(): string {
        if (isDevMode()) {
            if (this.practiceId && this.companyName) {
                return `http://localhost:52077/api_img/${this.practiceId}/${this.companyName}/estatements.png`;
            }
            else {
                return `http://localhost:52077/api_img/${this.practiceId}/estatements.png`;
            }
        }
        else {
            if (this.practiceId && this.companyName) {
                return `/api_img/${this.practiceId}/${this.companyName}/estatements.png`;
            }
            else {
                return `/api_img/${this.practiceId}/estatements.png`;
            }
        }
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./ClientApp/app/services/data.service.ts